module.exports = __webpack_public_path__ + "img/bannerBlue.fd463a83.jpg";